// extracted by mini-css-extract-plugin
module.exports = {"tabGrid":"gallery_tabGrid__zuO4O","quote":"gallery_quote__dTT9k","horizontalQuote":"gallery_horizontalQuote__aoyqW"};